export default "__VITE_ASSET__CF653DNY__"